import React, { useContext, useEffect, useState } from 'react';
import styled, {useTheme } from 'styled-components';
import { PageFull, PageTitle, Grey_Link, IconSvg, Slider_, On_Click_Card, CardsFull, PageSixty, PageAlwaysVisible, CardsSixty, Dropdown_, PageForty, THead, TH, TR, TBody, TD, Table, Main_Plain, device, logo, ThemeContext } from 'monica-alexandria';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getBreakdownView, getRetentionView, getRetentionViewAdvanced, getStatisticsSummary } from '../../../services/api/Statistics';
import { scaleLinear } from 'd3-scale';
import Graph_Box from '../../partials/graphBox/Graph_Box';
import Statistics_Breakdown from '../../partials/statistics/Statistics_Breakdown';
import Statistics_Summary from '../../partials/statistics/Statistics_Summary';
import Statistics_Grouping_Toggle from '../../partials/statistics/Statistics_Grouping_Toggle';
// import Statistics_Retention from '../dailyprofitStatistics/partials/Statistics_Retention';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Widget_Chart from '../../partials/widgetChart/Widget_Chart';



const WidgetBox = styled.div`
  background: ${p => p.theme.low};
  border-radius: var(--smallRadius);
  margin-bottom: 2rem;
  padding: var(--normalPads);
  cursor: pointer;
  transition: 0.2s ease;
  overflow-y: auto;
  height: 100%;              
  display: flex;
  flex-direction: column;    
  justify-content: center;
  /* align-self: stretch;   */
/* 
  h1{
    color: var(--main);
  } */
   p{
    font-size: 1.3rem;
   }

   &:hover {
    box-shadow: ${(p) => p.theme.outFocus};
    transition: box-shadow 0.5s;
  }

`;



const WidgetTop = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;

  img {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: var(--smallRadius);
  }
`

const WidgetChartWrapper = styled.div`
  padding-top: 2rem;
`

const TestGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr ;
  gap:1rem;
  margin-top: 1rem;
`



export default function RetentionStatistics() {
  const [structuredData, setStructuredData] = useState([]);
  const [xLabels, setXLabels] = useState([]);
  const [mode, setMode] = useState('sum');
  const [slider,setSlider] = useState(false)
  const [rawData, setRawData] = useState({});
  const [kpiData, setKpiData] = useState({});
  const [statisticsSum, setStatisticsSum] = useState([])
  const [statisticsBondSum, setStatisticsBondSum] = useState([])
  const [streams, setStreams] = useState(['dailyprofit','lois','bond','shift'])
  const [groupBy, setGroupBy] = useState('subscription');
  const navigate = useNavigate();
  const { t } = useTranslation();
  const themeProp = useTheme();
  const [selectedKpi, setSelectedKpi] = useState('')
  const [average, setAverage] = useState(0);
  const {theme} = useContext(ThemeContext);
  const months = Object.keys(kpiData.breakdown || {});

  const flatValues = structuredData.flat().map(cell => cell.sum || 0);
  const maxValue = Math.max(...flatValues, 1); // prevent division by zero

  const mainLight = getComputedStyle(document.documentElement).getPropertyValue('--mainLight').trim() || '#d6e685';
  const mainDark = getComputedStyle(document.documentElement).getPropertyValue('--mainDark').trim() || '#1e6823';


  const keys = Object.keys(kpiData?.breakdown || {});
  const lastKey = keys[keys?.length - 1];
  const lastValue = lastKey ? kpiData.breakdown[lastKey] : null;
  const colorScale = scaleLinear().domain([0, maxValue]).range([mainLight, mainDark]);

  let monthKeys = Object.keys(kpiData?.breakdown || {});


  const handleSelectedKpi  = (selectedKey) =>{
    const keys = Object.keys(kpiData?.breakdown || {});
  
    const lastKey = monthKeys[monthKeys?.length - 1];

    const selectedValue = selectedKey === 'last' ? kpiData?.breakdown[lastKey] : kpiData?.breakdown[selectedKey]
    setSelectedKpi({value: selectedValue, key: selectedKey === 'last' ? lastKey :  selectedKey})
  }


  const keysTest = [
    {value: "activeTotal", text:'Total active'},
    {value: "newPaid", text: "New paid"},
    {value:"returning", text: "Returning"},
    {value: "lost", text: "Lost"},
    {value: "activeQuests", text: "Active quests"},
    {value: "newActiveQuests", text: "New quests"}
  ];

  // getBreakdownView(['lois'], '2024-04-01', '2024-05-01')
  const get_breakdown_view = async (product) => {
    try {
      const products = product === 'allProducts' ? ['dailyprofit', 'lois', 'bond', 'shift'] : [product];
      const res = await getBreakdownView(products, undefined, undefined, groupBy);
      setKpiData(prev => ({
        ...prev,
        [product]: res?.data?.data?.breakdown || {}
      }));
    } catch (error) {
      console.error(`Failed to fetch breakdown for ${product}:`, error);
    }
  };


  const get_statistics_summary = (product) =>{
    const products = product === 'allProducts' ? ['dailyprofit', 'lois', 'bond', 'shift'] : [product];
    getStatisticsSummary(products, undefined, undefined, groupBy).then(res => {
      setStatisticsSum(prev => ({
        ...prev,
        [product]: res?.data?.data || {}
      }));
    });
  }



  const transformData = (raw, key = 'sum') => {
      const yLabels = Object.keys(raw);
      const xLabelSet = new Set();

      yLabels.forEach(label => {
        Object.keys(raw[label]).forEach(month => xLabelSet.add(month));
      });

      const xLabels = Array.from(xLabelSet).sort();
      const structuredData = yLabels.map(label =>
        xLabels.map(month => raw[label][month] || { sum: 0, loyal: 0, returning: 0 })
      );

    return { xLabels, data: structuredData };
  };

    useEffect(() => {
      getRetentionViewAdvanced(undefined, groupBy).then(res => {
        const data = Object.values(res?.data?.data)?.flatMap(months =>
          Object.values(months).map(val => val?.sum || 0)
        );
        const avg = data.reduce((a, b) => a + b, 0) / data.length;
        setAverage(Math.round(avg));
      });
    }, [groupBy]);


    useEffect(() => {
      getRetentionViewAdvanced(undefined, groupBy)
        .then(res => {
          setRawData(res.data.data);
          const transformed = transformData(res.data.data, mode);
          setXLabels(transformed.xLabels);
          setStructuredData(transformed.data);
        })
        .catch(err => console.log(err));
    }, [mode, groupBy]);

    const getMonthDifference = (data, kpiKey, productKey) => {
      if (!data?.[productKey]) return null;
    
      const months = Object.keys(data[productKey]).sort(); // Ensure chronological order
      const len = months.length;
      if (len < 2) return null;
    
      const currentMonth = months[len - 1];
      const previousMonth = months[len - 2];
    
      const currentValue = data[productKey][currentMonth]?.[kpiKey] || 0;
      const previousValue = data[productKey][previousMonth]?.[kpiKey] || 0;
    
      return {
        currentMonth,
        previousMonth,
        value: currentValue - previousValue,
        currentValue,
        previousValue
      };
    };
    


  useEffect(() => {
    if (kpiData?.breakdown && Object.keys(kpiData.breakdown).length > 0) {
      handleSelectedKpi('last');
    }
  }, [kpiData]);

  useEffect(() => {
    const fetchAllBreakdowns = async () => {
      await Promise.all([
        get_breakdown_view('lois'),
        get_breakdown_view('dailyprofit'),
        get_breakdown_view('bond'),
        get_breakdown_view('shift'),
        get_breakdown_view('allProducts'),
        get_statistics_summary('lois'),
        get_statistics_summary('dailyprofit'),
        get_statistics_summary('bond'),
        get_statistics_summary('shift'),
        get_statistics_summary('allProducts')
      ]);
    };
  
    fetchAllBreakdowns();
  }, [groupBy]);

  console.log('erawyData', rawData);
  console.log('statsum', statisticsSum);
  console.log('kpi', kpiData);


  const bondDiff = getMonthDifference(kpiData, 'activeTotal', 'bond');
  const loisDiff = getMonthDifference(kpiData, 'activeTotal', 'lois');
  const dailyprofitDiff = getMonthDifference(kpiData, 'activeTotal', 'dailyprofit');
  const shiftDiff = getMonthDifference(kpiData, 'activeTotal', 'shift');
  const allProductsDiff = getMonthDifference(kpiData, 'activeTotal', 'allProducts');

  return (
    <PageFull>
      <PageAlwaysVisible>
        {slider ? 
          <Slider_
            title={t("")} 
            onClick={()=>setSlider(false)}
            grey={t("Cancel")}
            icon="Check"
            iconGreyLeft="Xicon"
            onClose={()=>setSlider(false)}
            onGrey={()=>setSlider(false)}
            text={t("Done")}
          >
            {/* {slider === 'retention' && structuredData.length > 0 && (
                <Statistics_Retention structuredData={structuredData} xLabels={xLabels} />
            )} */}

            {slider === 'stats' ?
              <Statistics_Breakdown 
                viewLimit={months?.length} 
                keysTest={keysTest} 
                months={months} 
                kpiData={kpiData} 
                setStreams={setStreams} 
                streams={streams }  
                get_breakdown_view={get_breakdown_view}
              
              /> 
            : null}
          </Slider_>
        :null}

        <PageTitle>
          <Grey_Link noPadding iconLeft="Back" onClick={() => navigate(-1)} />
          <h1>{t('Statistics')}</h1>
          <Statistics_Grouping_Toggle groupBy={groupBy} onChange={setGroupBy} />
          
        </PageTitle>

        {/* <StatsSumWrapper>
          <Statistics_Summary statistics={statisticsSum} title='Questad'/>
        </StatsSumWrapper>

        <StatsSumWrapper>
          <Statistics_Summary statistics={statisticsBondSum} title='Pocket agency'/>
        </StatsSumWrapper> */}

        <TestGrid>
          <WidgetBox onClick={()=>navigate(`all-products`)}>
              <WidgetTop>
                <h4>All products</h4>
              </WidgetTop>

              <h1>{statisticsSum?.allProducts?.activeTotal}</h1>
              <p>{allProductsDiff ? (allProductsDiff.value >= 0 ? '+' : '') + allProductsDiff.value + ' this month' : 'N/A'}</p>

              <WidgetChartWrapper>
                <Widget_Chart kpiData={kpiData?.allProducts || []} />
              </WidgetChartWrapper>
          </WidgetBox>

          <WidgetBox onClick={()=>navigate(`questad`)}>
              <WidgetTop>
                <h4>Questad</h4>
                <img src={logo.dailyprofit[theme]} title='Questad'/>
              </WidgetTop>

              <h1>{statisticsSum?.dailyprofit?.activeTotal}</h1>
              <p>{dailyprofitDiff ? (dailyprofitDiff.value >= 0 ? '+' : '') + dailyprofitDiff.value + ' this month' : 'N/A'}</p>

              <WidgetChartWrapper>
                <Widget_Chart kpiData={kpiData?.dailyprofit  || []} />
              </WidgetChartWrapper>
          </WidgetBox>

          <WidgetBox onClick={()=>navigate(`adsnap`)}>
              <WidgetTop>
                <h4>Adsnap</h4>
                <img src={logo.lois[theme]} title='Adsnap'/>
              </WidgetTop>

              <h1>{statisticsSum?.lois?.activeTotal}</h1>
              <p>{loisDiff ? (loisDiff.value >= 0 ? '+' : '') + loisDiff.value + ' this month' : 'N/A'}</p>

              <WidgetChartWrapper>
                <Widget_Chart kpiData={kpiData?.lois  || []} />
              </WidgetChartWrapper>
          </WidgetBox>

          <WidgetBox  onClick={()=>navigate(`pocket-agency`)}>
              <WidgetTop>
                <h4>Pocket Agency</h4>
                <img src={logo.bond[theme]} title='Pocket agency'/>
              </WidgetTop>

              <h1>{statisticsSum?.bond?.activeTotal}</h1>
              <p>{bondDiff ? (bondDiff.value >= 0 ? '+' : '') + bondDiff.value + ' this month' : 'N/A'}</p>
              <WidgetChartWrapper>
                <Widget_Chart kpiData={kpiData?.bond || []} />
              </WidgetChartWrapper>
          </WidgetBox>

          <WidgetBox onClick={()=>navigate(`shift`)}>
              <WidgetTop>
                <h4>Shift</h4>
                <img src={logo?.shift?.[theme] || logo?.lois?.[theme]} title='Shift'/>
              </WidgetTop>

              <h1>{statisticsSum?.shift?.activeTotal}</h1>
              <p>{shiftDiff ? (shiftDiff.value >= 0 ? '+' : '') + shiftDiff.value + ' this month' : 'N/A'}</p>

              <WidgetChartWrapper>
                <Widget_Chart kpiData={kpiData?.shift || []} />
              </WidgetChartWrapper>
          </WidgetBox>
        </TestGrid>
{/*        
        <WidgetGrid>
          
          <WidgetBox onClick={() => setSlider('retention')}>
        
            <WidgetTitle>{'Retention'}</WidgetTitle>
            <WidgetMetric>{average}</WidgetMetric>
            <p>{t('Avg. Retention')}</p>
          
            <WidgetContent>
              {structuredData?.map((row, i) => (
                  <Row key={i}>
                    {row.map((cellData, j) => {
                      const sum = cellData.sum || 0;
                      const backgroundColor = sum === 0 ? themeProp.mid : colorScale(sum);
                      
                      return (
                        <WidgetCell key={j} style={{ backgroundColor }}  title={`Total: ${sum}\nLoyal: ${cellData.loyal}\nReturning: ${cellData.returning}\nRetention: ${''}%`}>
                          {sum > 0 && <CellContent value={sum}/>}
                        </WidgetCell>
                      );
                    })}
                  </Row>
                ))}
            </WidgetContent>
          </WidgetBox>
          <WidgetBox >
            <Statistics_Breakdown 
              onViewAll={()=> setSlider('stats')}
              viewLimit={8}  
              keysTest={keysTest} 
              months={months} 
              kpiData={kpiData} 
              setStreams={setStreams} 
              streams={streams }  
              get_breakdown_view={get_breakdown_view}
              /> 
          </WidgetBox>  
        </WidgetGrid> */}

      </PageAlwaysVisible> 
    </PageFull>
  );
}
